import PropTypes from 'prop-types'
import InfoModal from '../../../common/InfoModal'

import { ReactComponent as WarningIcon } from '../../../../assets/images/common/icons/warning-icon.svg'
import colors from '../../../../assets/styles/globals.scss'

const DefaultBodyText = () => (
  <>
    <p>
      This package has no current enrollments, <b>but it may be attached to one or more programs</b>.
    </p>
    <p>
      If you delete it, it will be removed from all associated programs and will no longer be able to receive new enrollment requests.
    </p>
    <p style={{ color: colors.red }}>
      <strong>This action is permanent and cannot be undone.</strong>
    </p>
  </>
)

const SingleWithinProgramBodyText = () => (
  <>
    <p>
      This package has no associated enrollments <b>but it is the only online payment option for at least one program.</b>
    </p>
    <p>
      <b>If you delete it:</b>
      <ul>
        <li>Those programs will immediately switch to offline-only payments.</li>
        <li>Online payments will be disabled until a new online package is added.</li>
      </ul>
    </p>
    <p>Programs can only accept online payments if they have an active online package assigned.</p>
    <p style={{ color: colors.red }}>
      <strong>This action is permanent and cannot be undone.</strong>
    </p>
  </>
)

const DeletePackageConfirmationModal = ({ isSingleWithinProgram, ...props }) => (
  <InfoModal
    title='Delete Package?'
    icon={<WarningIcon />}
    buttonMessage='Delete'
    {...props}
  >
    <div className='mx-4 text-left'>
      {isSingleWithinProgram ? <SingleWithinProgramBodyText /> : <DefaultBodyText />}
    </div>
  </InfoModal>
)

DeletePackageConfirmationModal.propTypes = {
  isSingleWithinProgram: PropTypes.bool,
}

export default DeletePackageConfirmationModal
